import React, { useState } from "react";
import "../assets/css/payment.css";
import bankTransfer from "../assets/images/bank-transfer.jpg";
import paypal from "../assets/images/credit-card.avif";
import Modal from "./Modal";

const Payment = () => {
  const [modal, setModal] = useState(false);
  return (
    <>
      <div className="payment-container">
        <h3>Payment Options</h3>
        <div className="payment-content">
          <div className="payment-option" onClick={() => setModal(true)}>
            <div>
              <p>Bank Transfer</p>
              <img src={bankTransfer} alt="bank transfer" width={100} />
            </div>
          </div>
          <div className="payment-option">
            <a
              href="https://paystack.com/pay/nexacadbootcamp"
              target="_blank"
              rel="noreferrer"
            >
              <div>
                <p>Credit Card</p>
                <img src={paypal} alt="bank transfer" width={100} />
              </div>
            </a>
          </div>
        </div>
        <Modal modal={modal} setModal={setModal} />
      </div>
    </>
  );
};

export default Payment;
